// Conta que a empresa cadastra para RECEBER depositos. Dois tipos: FIAT e CRYPTO.

export enum DepositAccountType {
  FIAT = "FIAT",
  CRYPTO = "CRYPTO",
}

export enum FiatTransferType {
  TED = "TED",
  PIX = "PIX",
}

export interface BankOption {
  id: number;
  name: string;
}

export interface NetworkOption {
  id: number;
  name: string;
}

export interface DepositAccountFormOptions {
  banks: BankOption[];
  networks: NetworkOption[];
}

// Contas de deposito agrupadas por empresa — usado na home do cliente, que
// pode estar vinculado a mais de uma empresa.
export interface ClientDepositGroup {
  organizationId: number;
  organizationName: string;
  accounts: DepositAccount[];
}

export interface DepositAccount {
  id: number;
  organization_id: number;
  type: DepositAccountType;
  nickname: string;
  // FIAT
  bank_id: number | null;
  agency: string | null;
  account: string | null;
  transfer_type: FiatTransferType | null;
  bank: BankOption | null;
  // CRYPTO
  network_id: number | null;
  hash: string | null;
  network: NetworkOption | null;
  createdAt: string;
  updatedAt: string;
}

// Payload enviado ao backend. Deve conter SOMENTE estes campos: o ValidationPipe
// do otc-core roda com forbidNonWhitelisted, entao campos extras sao rejeitados.
export interface CreateDepositAccountDto {
  type: DepositAccountType;
  nickname: string;
  // FIAT
  bank_id?: number;
  agency?: string;
  account?: string;
  transfer_type?: FiatTransferType;
  // CRYPTO
  network_id?: number;
  hash?: string;
}
